module.exports = __webpack_public_path__ + "static/img/label-04.e330b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/label-04.png
// module id = hs6R
// module chunks = 150